import { Component } from '@verndale/core';
import { s } from './cookie-util';
import SanitizeText from '../services/GlobalServices';

class LoginModal extends Component {
  loginForm: HTMLFormElement;
  defaultShowUrls:string[];
  backgroundElements : NodeListOf<HTMLElement>;
  constructor(el: HTMLElement) {
    super(el);
    this.loginForm= this.el.querySelector('#loginForm') as HTMLFormElement;
    this.backgroundElements = document.querySelectorAll('header,main,footer,.consentbanner');
    this.defaultShowUrls=[];
  }
  setupDefaults() {
    this.dom = {
      triggers: document.querySelectorAll('.login-trigger'),
      modal: this.el.querySelector('.login-dialog') as HTMLElement,
      close: this.el.querySelector('.btn-close') as HTMLElement,
      
    };   
    this.loginForm=this.el.querySelector('#loginForm') as HTMLFormElement
    const d=this.el.getAttribute('data-default-show-url')??"";
    this.defaultShowUrls=  d.split(",");
  }

  openModal() {
    this.loginForm.reset();
    const f = this.dom.modal as HTMLElement;
    f.classList.remove('hide');
    
    this.backgroundElements.forEach(el => {
      el.setAttribute('inert', 'true');
    });
  }

  closeModal() {
    const f = this.dom.modal as HTMLElement;
    this.loginForm.reset();
    f.classList.add('hide');
    this.backgroundElements.forEach(el => {
     el.removeAttribute('inert');
    });
  }

  handleInvalid(e: Event) {
    console.log('Invalid input detected');
    const input = e.target as HTMLInputElement;
    input.classList.add('submit-attempted');
  }

  formSubmit(e: Event) {
    console.log('formSubmit called');
    e.preventDefault();    
    const userId = this.loginForm['userid'].value;
    s('username', userId, 1);
    this.loginForm.method = 'post';
    this.loginForm.submit();
  }
  santizeText(e:Event){
    const input = e.target as HTMLInputElement;
    input.value=SanitizeText({input:input.value,onlyHtml:true})??"";
  }
  addListeners(): void {
    (this.dom.triggers as NodeList).forEach(trigger =>
      trigger.addEventListener('click', this.openModal.bind(this))
    );
    (this.dom.close as HTMLElement).addEventListener('click', this.closeModal.bind(this));
    this.loginForm.addEventListener('submit', this.formSubmit.bind(this));
    // Add invalid event listeners to all inputs
    
    const inputs = this.loginForm.querySelectorAll('input');
    const links = this.el.querySelectorAll('a');
    links.forEach((link: HTMLAnchorElement) => {
      link.addEventListener('click', this.closeModal.bind(this));
    });
    inputs.forEach((input: HTMLInputElement) => {
      input.addEventListener('invalid', this.handleInvalid.bind(this));
      input.addEventListener('change', this.santizeText.bind(this));

    });
    if(this.defaultShowUrls.includes(window.location.pathname)){
      this.openModal()
    }
    
  }
}

export default LoginModal;
